"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventAction;
(function (EventAction) {
    EventAction["SendCommand"] = "sendCommand";
    EventAction["StartLoading"] = "startLoading";
    EventAction["StopLoading"] = "stopLoading";
    EventAction["HeightChange"] = "heightChange";
    EventAction["StateChangeSuccess"] = "stateChangeSuccess";
    EventAction["ShowModal"] = "showModal";
    EventAction["HideNavbar"] = "hideNavbar";
    EventAction["ShowNavbar"] = "showNavbar";
    EventAction["GetCurrentLanguage"] = "getCurrentLanguage";
    EventAction["Toast"] = "toast";
    EventAction["GetApplication"] = "getApplication";
    EventAction["HasPermissions"] = "hasPermissions";
    EventAction["GetPermissionsObject"] = "getPermissionsObject";
    EventAction["Segment"] = "segment";
})(EventAction = exports.EventAction || (exports.EventAction = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnRBY3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0V2ZW50QWN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQVksV0FlWDtBQWZELFdBQVksV0FBVztJQUNyQiwwQ0FBMkIsQ0FBQTtJQUMzQiw0Q0FBNkIsQ0FBQTtJQUM3QiwwQ0FBMkIsQ0FBQTtJQUMzQiw0Q0FBNkIsQ0FBQTtJQUM3Qix3REFBeUMsQ0FBQTtJQUN6QyxzQ0FBdUIsQ0FBQTtJQUN2Qix3Q0FBeUIsQ0FBQTtJQUN6Qix3Q0FBeUIsQ0FBQTtJQUN6Qix3REFBeUMsQ0FBQTtJQUN6Qyw4QkFBZSxDQUFBO0lBQ2YsZ0RBQWlDLENBQUE7SUFDakMsZ0RBQWlDLENBQUE7SUFDakMsNERBQTZDLENBQUE7SUFDN0Msa0NBQW1CLENBQUE7QUFDckIsQ0FBQyxFQWZXLFdBQVcsR0FBWCxtQkFBVyxLQUFYLG1CQUFXLFFBZXRCIn0=